import {
    Activity,
    Bot,
    FileText,
    Home,
    MousePointer,
    PartyPopper,
    Sparkles,
    TestTube,
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function Navigation() {
    const location = useLocation();

    const navItems = [
        { path: '/', label: 'Main App', icon: Home },
        { path: '/cta-test', label: 'CTA Test', icon: MousePointer },
        { path: '/form-test/demo', label: 'Form Test', icon: FileText },
        { path: '/ai-sections', label: 'AI Sections', icon: Sparkles },
        { path: '/form-assistant', label: 'Form Assistant', icon: Bot },
        { path: '/thank-you', label: 'Post-Conversion', icon: PartyPopper },
        { path: '/status', label: 'Backend Status', icon: Activity },
    ];

    // Only show navigation on test pages (not on main app)
    if (location.pathname === '/') {
        return null;
    }

    return (
        <div className="fixed top-4 left-4 z-50">
            <div className="bg-white/95 backdrop-blur-sm rounded-lg border border-gray-200 shadow-lg p-1.5 flex flex-col gap-1">
                <div className="p-1 text-gray-400" title="Test Navigation">
                    <TestTube className="h-4 w-4" />
                </div>
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive =
                        location.pathname === item.path ||
                        (item.path === '/form-test/demo' &&
                            location.pathname.startsWith('/form-test/'));

                    return (
                        <Button
                            key={item.path}
                            asChild
                            variant={isActive ? 'default' : 'ghost'}
                            size="icon"
                            className={`h-8 w-8 ${
                                isActive
                                    ? 'bg-blue-600 text-white'
                                    : 'text-gray-500 hover:text-gray-900'
                            }`}
                            title={item.label}
                            aria-label={item.label}
                        >
                            <Link to={item.path}>
                                <Icon className="h-4 w-4" />
                            </Link>
                        </Button>
                    );
                })}
            </div>
        </div>
    );
}
